import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import ReactGA from 'react-ga';

class IntroHelmet extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.selected !== nextProps.selected;
  }

  render() {
    const {url, selected} = this.props;

    if (selected) {
      const path = `${url}/${selected}`;

      return (
        <Helmet
          onChangeClientState={(newState) => {
            ReactGA.set({page: path});
            ReactGA.pageview(path, [], newState.title);
          }}>
          <title>{path}</title>
        </Helmet>
      );
    }
    else {
      return null;
    }
  }
}

export default IntroHelmet;



// WEBPACK FOOTER //
// ./src/app/intro/components/IntroHelmet/IntroHelmet.js